import React, { useEffect, useState } from 'react';
import {
    Dialog,
    Box,
    Typography,
    Button,
    IconButton,
    Stack,
    Divider,
    Grid,
    Chip
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { get, map, find } from "lodash";
import CloseIcon from '@mui/icons-material/Close';
import Alert from "../../../../components/form/Alert";
import Table from "../../../../components/form/TableDetail";

import { useParams } from 'react-router-dom';
import { useCanView } from "../../../../config/hook/UserPermissions";

const ContactModal = ({
    __,
    open,
    close
}) => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
    const canView = useCanView();

    const log = useSelector(state => state.config.log);
    const logActions = __(`logActions`, { returnObjects: true });

    const onCloseModal = (r) => {
        close()
    }

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const headTable = [
        {
          key: "docId",
          label: __(`table.cols.docId`),
          align: "center"
        },
        {
          key: "maeId",
          label: __(`table.cols.maeId`),
          align: "center"
        },
        {
          key: "action",
          label: __(`table.cols.action`),
          align: "center"
        },
        {
          key: "date",
          label: __(`table.cols.date`),
          align: "center"
        },
        {
          key: "screen",
          label: __(`table.cols.screen`),
          align: "center"
        },
        {
          key: "users",
          label: __(`table.cols.users`),
          align: "center"
        },
      ]
    
      const dataTable = map(get(log, "data.data", []), (row, i) => ({
        ...row,
        action: <Chip label={get(find(logActions, ({ value }) => value === get(row, "action", 1)), "label")} sx={{ bgcolor: `${get(find(logActions, ({ value }) => value === get(row, "action", 1)), "color")}26`, color: get(find(logActions, ({ value }) => value === get(row, "action", 1)), "color") }} />,
        date: new Date(get(row, "date")).toISOString().replace('T', ' ').split('.')[0], 
      }));

    return (
        <div>
            <Dialog onClose={onCloseModal} open={open} maxWidth="lg" fullWidth>
                <Box>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1, ml: 3 }}>
                        {__("labels.5")}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={onCloseModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                < Divider/>
                <Table
                    headTable={headTable}
                    dataTable={dataTable}
                    __={__}
                    sizeFilters={125}
                    loading={get(log, "isLoading", false)}
                    empty="orders"
                    propsTable={{
                        size: "small"
                    }}
                />
                <Alert
                    title={get(alert, "title")}
                    subtitle={get(alert, "subtitle")}
                    btn1={{ func: get(alert, "func") }}
                    btn2={{}}
                    type={get(alert, "type")}
                    openAlert={get(alert, "open")}
                    closeAlert={closeAlert}
                />
            </Dialog>
        </div>
    );
}

export default ContactModal